module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-md-1-5 pure-u-lg-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-3-5 pure-u-lg-1-2"
  }, [_c('div', {
    staticClass: "content box padding-30-reactive"
  }, [_c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1 spacing-30"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-7-8 text-center visible-sm"
  }, [_c('button', {
    staticClass: " pure-button pure-button-primary block",
    on: {
      "click": function($event) {
        return _vm.$emit('success')
      }
    }
  }, [_vm._v("Register")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-11-24 hidden-sm "
  }, [_c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-sm-1-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-7-8 text-center"
  }, [_c('button', {
    staticClass: " pure-button pure-button-primary block",
    on: {
      "click": function($event) {
        return _vm.$emit('success')
      }
    }
  }, [_vm._v("Register")])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-11-24"
  }, [_c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1 pure-u-sm-7-8 text-center"
  }, [_c('button', {
    staticClass: " pure-button pure-button-primary block",
    on: {
      "click": function($event) {
        return _vm.$emit('login')
      }
    }
  }, [_vm._v(" Login")])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-sm-1-8"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 spacing-20"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-sm-11-24"
  }, [_c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-sm-1-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-7-8 text-center"
  }, [_c('h3', {
    staticClass: "margin-bottom-10 responsive"
  }, [_vm._v(" New Account")]), _vm._v(" "), _c('div', {
    staticClass: "subtext-lg margin-left-10"
  }, [_vm._v(" Don't have a Tavour account? ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-sm-2-24"
  }, [_c('div', {
    staticClass: "vertical-line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 visible-sm "
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-sm-11-24"
  }, [_c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1 pure-u-sm-7-8 text-center"
  }, [_c('h3', {
    staticClass: "margin-bottom-10 responsive"
  }, [_vm._v("Returning Tavour Member")]), _vm._v(" "), _c('div', {
    staticClass: "subtext-lg margin-left-10"
  }, [_vm._v("Login to speed up the signup process.")])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-sm-1-8"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-sm-2-24"
  }, [_c('div', {
    staticClass: "vertical-line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50e7635a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/start/Start.vue
// module id = 381
// module chunks = 1